import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ea3dc3fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title"]
const _hoisted_2 = {
  key: 0,
  class: "flex items-center px-1 min-w-0 text-[10.5px] font-bold text-[#34344F]"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "truncate" }, "Ocupado", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "flex items-center gap-1 min-w-0" }
const _hoisted_6 = {
  class: "unidentified-row__avatar",
  "aria-hidden": "true"
}
const _hoisted_7 = ["d"]

import { computed } from 'vue'
import { mdiAccountOutline } from '@mdi/js'
import {
  UNIDENTIFIED_COVERAGE_COLORS as COLORS,
  unidentifiedCoverageStripes,
  unidentifiedCoverageTooltipParts
} from './unidentifiedCoverageStyles'


export default /*#__PURE__*/_defineComponent({
  __name: 'unidentified',
  props: {
    responsibleName: { default: null },
    note: { default: null },
    compact: { type: Boolean, default: false },
    mobile: { type: Boolean, default: false },
    autoHeight: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit }) {

const props = __props;

_useCssVars(_ctx => ({
  "255ac0f4": (_unref(stripes)),
  "fce850e2": (_unref(stripesCompact)),
  "0b660048": (_unref(accent)),
  "069c8184": (_unref(border)),
  "3bf72cbf": (_unref(text))
}))





const tooltip = computed(() =>
  unidentifiedCoverageTooltipParts(props.responsibleName, props.note).join(' · ')
)

// Consumidos via v-bind() no <style> (fonte única das cores em unidentifiedCoverageStyles.ts)
const stripes = unidentifiedCoverageStripes(7)
const stripesCompact = unidentifiedCoverageStripes(5)
const accent = COLORS.accent
const border = COLORS.border
const text = COLORS.text

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    role: "button",
    tabindex: "0",
    class: _normalizeClass(["unidentified-row flex w-full overflow-hidden", 
      _ctx.compact
        ? 'unidentified-row--compact h-6'
        : _ctx.autoHeight
          ? 'min-h-[34px]'
          : 'h-[72px] md:h-[105px]'
    ]),
    title: tooltip.value,
    "data-testid": "unidentified-coverage-row",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click'))),
    onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (emit('click')), ["enter"]))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["unidentified-row__bar", _ctx.compact ? 'w-1.5' : _ctx.autoHeight ? 'w-2' : 'w-2 md:w-3'])
    }, null, 2),
    (_ctx.compact)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["flex flex-col w-full min-w-0 px-1.5 py-1", [_ctx.autoHeight ? '' : 'md:px-2 md:py-1.5', 'text-left']])
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              (_openBlock(), _createElementBlock("svg", {
                viewBox: "0 0 24 24",
                class: _normalizeClass(["w-2.5 h-2.5", _ctx.autoHeight ? '' : 'md:w-3 md:h-3'])
              }, [
                _createElementVNode("path", {
                  d: _unref(mdiAccountOutline),
                  fill: "currentColor"
                }, null, 8, _hoisted_7)
              ], 2))
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(["font-bold text-[#34344F]", [
            _ctx.autoHeight ? 'break-words' : 'truncate',
            _ctx.mobile || _ctx.autoHeight ? 'text-[11px]' : 'text-[9px] md:text-[11px]'
          ]])
            }, "Ocupado", 2)
          ]),
          _createElementVNode("span", {
            class: _normalizeClass(["text-[#374151] pl-[18px]", [
          _ctx.autoHeight ? '' : 'md:pl-[22px]',
          _ctx.mobile || _ctx.autoHeight ? 'text-[10px]' : 'text-[8px] md:text-[9.5px]'
        ]])
          }, " s/ identificação ", 2),
          (_ctx.responsibleName)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["unidentified-row__tag", {
          'unidentified-row__tag--mobile': _ctx.mobile || _ctx.autoHeight,
          'unidentified-row__tag--wrap': _ctx.autoHeight
        }]),
                "data-testid": "unidentified-coverage-responsible-tag"
              }, _toDisplayString(_ctx.responsibleName), 3))
            : _createCommentVNode("", true)
        ], 2))
  ], 42, _hoisted_1))
}
}

})